export default __webpack_public_path__ + "static/media/logo-medium.e5797c93.png";